import { UserRole } from '@/types'

export const PERMISSIONS = {
  templates: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  assignments: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  reports: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  users: [UserRole.ADMIN],
  services: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  contracts: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  customers: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  resources: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  'resource-types': [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  // Lettura del listino e della fatturazione. La scrittura sul listino resta
  // ai soli admin ed e' imposta dal backend sulla rotta, non da qui.
  billing: [UserRole.ADMIN, UserRole.TECH_USER, UserRole.BCO_USER],
  // Lancio dei profili ApiTool dalla pagina Raccolta dati.
  apitool: [UserRole.ADMIN, UserRole.TECH_USER],
} as const

export type Feature = keyof typeof PERMISSIONS

export function canCheck(feature: Feature, userRole: UserRole): boolean {
  if (!userRole || userRole === UserRole.UNAUTHORIZED || (userRole as string) === 'unauthorized') {
    return false
  }
  const allowedRoles = PERMISSIONS[feature] as readonly UserRole[]
  return allowedRoles ? allowedRoles.includes(userRole) : false
}
